import { render, staticRenderFns } from "./CSVParser.component.vue?vue&type=template&id=0fcf6cf1&scoped=true"
import script from "./CSVParser.component.ts?vue&type=script&lang=js&external"
export * from "./CSVParser.component.ts?vue&type=script&lang=js&external"
import style0 from "./CSVParser.component.vue?vue&type=style&index=0&id=0fcf6cf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf6cf1",
  null
  
)

export default component.exports